import Vue from 'vue'
import numeral from 'numeral'
import moment from 'moment'

// numeral.zeroFormat('N/A')

Vue.filter('numberFormat', function(value, round=false, format='0,0.00a') {
    if (value == Infinity) return 'Infinity'
    return numeral(Math.round(value, 0)).format(round ? format : '0,0')
})

Vue.filter('percentFormat', function(value) {
    if (value == Infinity) return 'Infinity'
    return numeral(value).format('0,0.00%')
})

Vue.filter('roundedFormat', value => {
    return numeral(value).format('0a')
})

Vue.filter('errorFormat', value => {
    return numeral(value).format('0,0.00')
})

Vue.filter('dateFormat', function(value, format=null) {
    if (format == null)
        return moment(value).fromNow()
    else
        return moment(value).format(format)
})

Vue.filter('yearFormat', function(value) {
    return moment(value).format('YYYY')
})

Vue.filter('columnFormat', value => {
    return value.replace('_', ' ')
})

Vue.filter('byteFormat', value => {
    return numeral(value).format('0.0 b')
})

Vue.filter('capitalize', value => {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('uppercase', value => {
    return value.toUpperCase()
})

Vue.filter('round', value => {
    return numeral(value).format('0,0.00')
})

